import { inject, Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { IGlossary } from '@shared/interfaces/various/IGlossary';
import { UpdateGlossary } from '@monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class GlossaryService {
    private readonly apiUrl = '/glossaries';

    private readonly apiService = inject(ApiService);

    public getAllItems(): Promise<IGlossary[]> {
        return this.apiService.get(this.apiUrl);
    }

    public createItem(item: IGlossary): Promise<IGlossary> {
        return this.apiService.post(this.apiUrl, item);
    }

    public updateItem(item: IGlossary): Promise<IGlossary> {
        const dto: UpdateGlossary = {
            title: item.title,
            titleDe: item.titleDe,
            description: item.description,
            descriptionDe: item.descriptionDe
        };
        return this.apiService.patch(`${this.apiUrl}/${item.id}`, dto);
    }

    public deleteItem(item: IGlossary): Promise<boolean> {
        return this.apiService.delete(`${this.apiUrl}/${item.id}`);
    }
}
